module.exports = __webpack_public_path__ + "static/media/game-3-empty.66c0ab40.png";